<template>
  <v-container>
    <div v-if="$vuetify.breakpoint.xsOnly" class="d-flex justify-end">
      <v-btn
        class="book-appointment"
        outlined
        color="rgba(9, 109, 216, 1)"
        :disabled="!(profile.bookingTypes && profile.bookingTypes.length > 0)"
        @click.stop="bookingModal = !bookingModal"
      >
        Book appointment
      </v-btn>
    </div>
    <v-dialog persistent max-width="px">
      <v-card class="dialog-cls">
        <v-col cols="12">
          <v-alert
            color="#344452"
            border="left"
            elevation="2"
            colored-border
            icon="mdi-information"
            class="dialog-text mt-5"
            >Please Login to book the Appointment.
          </v-alert>
        </v-col>
        <v-col sm="12" md="12" lg="12">
          <v-btn
            color="#344452"
            dark
            block
            large
            :loading="loading"
            @click="login"
            >Login</v-btn
          >
        </v-col>
        <v-col sm="12" md="12" lg="12">
          <v-alert
            color="#344452"
            border="left"
            elevation="2"
            colored-border
            icon="mdi-information"
            class="dialog-text mt-2"
            >Want to change the Doctor? <a @click="changeDoctor">Click Here</a>.
          </v-alert>
        </v-col>
      </v-card>
    </v-dialog>
    <v-card-text v-if="isUserLoggedIn" class="dialog-text">
      <v-dialog v-model="dialog" width="500" persistent>
        <v-card class="dialog-cls">
          <v-card-title class="dialog-title"
            >Reason for Reschedule</v-card-title
          >
          <v-divider></v-divider>
          <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes }">
            <v-card-text>
              <VTextArea
                v-model="rescheduleReason"
                filled
                placeholder="Enter you reason here..."
                :rules="{ required: true }"
                counter="500"
                maxlength="500"
              ></VTextArea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false">Cancel</v-btn>

              <v-btn
                :disabled="invalid || !validated"
                color="#344452"
                :dark="!invalid"
                :loading="loading"
                @click="passes(doBooking)"
                >Submit</v-btn
              >
            </v-card-actions>
          </ValidationObserver>
        </v-card>
      </v-dialog>
    </v-card-text>

    <v-navigation-drawer
      v-model="bookingModal"
      app
      right
      temporary
      width="500px"
    >
      <ValidationObserver ref="obs" v-slot="{ invalid }">
        <v-card flat class="no-card-shadow">
          <v-card-title class="book-appointment-title">
            <span v-if="booking.status === APPOINTMENT_COMPLETED"
              >Schedule recurring appointment</span
            >
            <span v-else>Book an appointment</span>
            <v-spacer></v-spacer>
            <v-icon color="rgba(47, 76, 103, 1)" @click="bookingModal = false"
              >close</v-icon
            >
          </v-card-title>
          <v-card-text class="scroll-box">
            <v-row>
              <v-col cols="12" class="py-4">
                <span class="type-select ml-1">Appointment type</span>
                <VAutoComplete
                  :rules="{ required: true }"
                  :items="appointmentTypeList"
                  item-text="title"
                  v-model="selectedAppointmentType"
                  return-object
                  placeholder="Select appointment type"
                  class="list"
                  solo
                />
              </v-col>
              <v-col cols="12">
                <span class="type-select ml-1">Date</span>
                <VDate
                  label="Select the date"
                  v-model="booking.date"
                  :min="today"
                  solo
                  @change="getAllSlots"
                />
              </v-col>
              <!-- <v-col cols="6">
                <span class="type-select ml-1">Time</span>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <VueCtkDateTimePicker
                    input-size="lg"
                    class="mt-1"
                    v-model="booking.startHour"
                    :only-time="true"
                    label="Booking Time"
                    minute-interval="15"
                    :format="format"
                    :output-format="formatted"
                    :formatted="format"
                  /><span class="v-messages theme--light error--text">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </v-col> -->
              <v-col v-if="availableTimeSlots.length > 0" cols="12">
                <v-divider></v-divider
              ></v-col>
              <v-col
                v-if="availableTimeSlots.length > 0"
                cols="12"
                class="date-time"
                >Date + current time</v-col
              >
              <v-col
                :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
                v-for="(item, index) in availableTimeSlots"
                :key="index"
              >
                <v-btn
                  :class="
                    selectedSlot[0] &&
                    availableTimeSlots[index].indexOf(selectedSlot[0]) > -1
                      ? 'selected-style'
                      : ''
                  "
                  class="btn-style pa-0 "
                  @click="getSlots(item, index)"
                  block
                  outlined
                >
                  {{ item }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="d-flex justify-end pa-4">
            <v-btn
              text
              color="#6B6B6B"
              @click="bookingModal = false"
              class="cancel-btn text-transform"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="!bookingDetails.sourceId"
              :disabled="invalid"
              :loading="loading"
              color="#096DD8"
              class="text-transform"
              @click="bookingInitiated(false)"
            >
              Continue to payment
            </v-btn>
            <v-btn
              v-else-if="
                bookingDetails.sourceId &&
                  bookingDetails.status === APPOINTMENT_COMPLETED
              "
              :dark="!invalid"
              :disabled="invalid"
              :loading="loading"
              color="#096DD8"
              class="text-transform"
              @click="bookingInitiated(true)"
            >
              Continue to payment</v-btn
            >
            <v-btn
              v-else-if="booking.sourceId"
              color="#096DD8"
              :dark="!invalid"
              block
              class="text-transform"
              :disabled="invalid"
              :loading="loading"
              @click="updateBooking()"
              >Update booking</v-btn
            >
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-navigation-drawer>

    <div v-if="$vuetify.breakpoint.smAndUp" class="d-flex justify-end">
      <v-btn
        class="book-appointment"
        outlined
        color="rgba(9, 109, 216, 1)"
        :disabled="!(profile.bookingTypes && profile.bookingTypes.length > 0)"
        @click.stop="bookingModal = !bookingModal"
      >
        Book appointment
      </v-btn>
    </div>
    <!-- <v-dialog scrollable v-model="cardModal" persistent max-width="550px">
      <v-card>
        <v-card-title class="book-appointment-title">
          Book an appointment
          <v-spacer></v-spacer>
          <v-icon color="rgba(47, 76, 103, 1)" @click="cardModal = false"
            >close</v-icon
          >
          <v-card-subtitle class="px-0 py-1 card-sub">
            Enter payment details to request an appointment
          </v-card-subtitle>
        </v-card-title>
        <v-card-text class="scroll-box">
          <v-row>
            <v-col cols="12">
              <span class="payment-card-text">Card Number</span>
              <v-text-field
                prepend-inner-icon="mdi-credit-card-outline"
                solo
                placeholder="0000 0000 0000 0000"
              >
                <template #prepend-inner>
                  <img
                    src="@/assets/icons/ant-design_credit-card-outlined.svg"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="payment-card-text">Expiry date</span>
              <date-field label="MM/YY" solo> </date-field>
            </v-col>
            <v-col cols="6">
              <span class="payment-card-text">CVC/CVV</span>
              <v-text-field solo label="***">
                <template #prepend-inner>
                  <img src="@/assets/icons/bx_lock-alt.svg" />
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" class="px-2 py-0">
              <v-checkbox>
                <template v-slot:label>
                  <span class="save-details">
                    Save card details for future use
                  </span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <div><v-divider></v-divider></div>
          <v-row>
            <v-col cols="12">
              <span class="payment-text">Payment details</span>
            </v-col>
            <v-col cols="6">
              <span class="billDeatils-text">Appointment type :</span>
            </v-col>
            <v-col cols="6" class="text-right appointmentDetails-text">
              {{ selectedAppointmentType ? selectedAppointmentType.title : "" }}
            </v-col>
            <v-col cols="6">
              <span class="billDeatils-text">Doctor :</span>
            </v-col>
            <v-col cols="6" class="text-right appointmentDetails-text">
              {{ profile.firstName }}, {{ profile.title }}
            </v-col>
            <v-col cols="6">
              <span class="billDeatils-text">Date & Time :</span>
            </v-col>
            <v-col cols="6">
              <span class="float-right appointmentDetails-text">
                04.07.2022. 11:30 AM - 12:00 PM
              </span>
            </v-col>
          </v-row>
          <div class="border-payment"></div>
          <v-row>
            <v-col cols="6">
              <span class="billDeatils-text">Total price :</span>
            </v-col>
            <v-col cols="6" class="text-right appointmentDetails-text">
              <span>
                £
                {{
                  selectedAppointmentType ? selectedAppointmentType.fees : ""
                }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <div><v-divider></v-divider></div>
        <v-card-actions class="d-flex justify-end py-4 px-4">
          <v-btn
            text
            color="#6B6B6B"
            @click="cardModal = false"
            class="cancle-btn text-transform"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#096DD8"
            class="text-transform"
            @click="cardModal = false"
          >
            Pay and request appointment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import { ValidationObserver } from "vee-validate";
// import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
// import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { VAutoComplete, VTextArea, VDate } from "@/components/inputs";
import { HOURS, MINUTES, DOCTOR_TIME_DURATION } from "@/constants";
import { cloneDeep } from "lodash";
import moment from "moment";
import momentTimezone from "moment-timezone";
import { BookingService } from "@/services";
import { mapGetters } from "vuex";
import { APPOINTMENT_COMPLETED } from "@/constants";
export default {
  name: "Appointment",
  components: {
    ValidationObserver,
    VAutoComplete,
    VDate,
    VTextArea
    // ValidationProvider,
    // VueCtkDateTimePicker
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    },
    myAddress: {
      type: Object,
      default: () => ({})
    },
    bookingDetails: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      booking: this.bookingDetails,
      availableTimeSlots: [],
      formatted: "HH:mm",
      format: "hh:mm a",
      paymentModal: true,
      appointmentTypeList: [],
      selectedAppointmentType: {},
      dialog: false,
      cardDetails: false,
      modal1: false,
      menu2: false,
      APPOINTMENT_COMPLETED: APPOINTMENT_COMPLETED,
      bookingModal: false,
      cardModal: false,
      loading: false,
      disabled: true,
      // invalid: false,
      // disabled: false,
      availableHours: [],
      availableMinutes: {},
      selectHours: null,
      rescheduleReason: null,
      today: moment().format("YYYY-MM-DD"),
      startMinute: null,
      slot: {
        _startHours: cloneDeep(HOURS),
        _startMinutes: cloneDeep(MINUTES)
      },
      selectedSlot: []
    };
  },
  computed: {
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn"
    }),
    // doctorFees() {
    //   return this.profile.bookingTypes.fees || DOCTOR_FEES;
    // },
    timeDuration() {
      return this.profile.duration || DOCTOR_TIME_DURATION;
    }
  },
  watch: {
    bookingModal() {
      this.getTitleData();
      this.clearSlots();
    },
    bookingDetails() {
      this.appointmentTypeList = [...this.profile.bookingTypes];
      Object.assign(this.booking, this.bookingDetails);
      Object.assign(
        this.selectedAppointmentType,
        this.bookingDetails.bookingType
      );
      this.bookingModal = true;
    }
  },
  methods: {
    /* onDateChange() {
      this.availableHours = [];
      const bookingDay = moment(this.date, "yyyy-mm-dd").format("dddd");
      let availableSlots = this.myAddress.availability.filter(obj => {
        return obj.day === bookingDay;
      });
      if (availableSlots && availableSlots.length) {
        availableSlots = availableSlots[0];
        for (let i = 0; i < availableSlots.slots.length; i += 1) {
          const stHour = parseInt(
            moment(availableSlots.slots[i].startHour).format("HH")
          );
          const enHour = parseInt(
            moment(availableSlots.slots[i].endHour).format("HH")
          );
          const enMinutes = parseInt(
            moment(availableSlots.slots[i].endHour).format("mm")
          );
          const hourDiff = enHour - stHour;
          for (let j = 0; j <= hourDiff; j += 1) {
            if (j === hourDiff && enMinutes) {
              this.availableHours.push(stHour + j);
            } else if (j !== hourDiff) {
              this.availableHours.push(stHour + j);
            }
          }
          let minutes = 0;
          for (let index = 0; index < this.availableHours.length; index++) {
            const element = this.availableHours[index];
            minutes += this.timeDuration;
            this.availableMinutes[element] = [];
            if (this.timeDuration > 30) {
              if (minutes > 60) {
                minutes -= 60;
              }
              this.availableMinutes[element].push(minutes);
            } else {
              const length = 60 / this.timeDuration;
              for (let j = 0; j < length; j++) {
                if (minutes > 60) {
                  minutes -= 60;
                }
                if (
                  minutes === 60 &&
                  this.availableMinutes[element].length === 0
                ) {
                  this.availableMinutes[element].push(0);
                } else if (minutes !== 60) {
                  this.availableMinutes[element].push(minutes);
                }
                minutes += this.timeDuration;
              }
            }
          }
        }
      }
    }, */

    getSlots(value) {
      if (this.selectedSlot.join("-") == value) {
        this.selectedSlot = [];
      } else {
        this.selectedSlot = value.split("-");
      }
    },
    async getAllSlots() {
      const request = await BookingService.getBookingSlots({
        doctorId: this.$route.params.doctorId,
        typeId: this.selectedAppointmentType._id,
        date: this.booking.date
      });
      if (request) {
        this.availableTimeSlots = [...request.data];
      }
    },
    clearSlots() {
      this.availableTimeSlots = [];
    },
    getTitleData() {
      this.appointmentTypeList = [...this.profile.bookingTypes];
      if (!this.bookingDetails.sourceId) {
        this.booking = {};
        this.selectedAppointmentType = {};
      }
    },
    /* allowedHours(h) {
      if (this.availableHours.indexOf(h) !== -1) {
        return true;
      }
      return false;
    },
    saveSelectHours(h) {
      this.selectHours = h;
    },
    allowedStep(m) {
      if (
        this.availableMinutes[this.selectHours] &&
        this.availableMinutes[this.selectHours].indexOf(m) !== -1
      ) {
        return true;
      }
      return false;
    },
    save(time, dialog, sloatIndex) {
      this.$refs[dialog][sloatIndex].save(time);
    }, */
    getUtcDates() {
      // const localStartHour = moment(this.booking.date)
      //   .startOf("day")
      //   .add(this.booking.startHour.split(":")[0], "h")
      //   .add(this.booking.startHour.split(":")[1], "minutes");
      // const utcStartHour = moment(new Date(localStartHour)).toISOString();

      // const utcEndHour = moment(utcStartHour)
      //   .add(this.selectedAppointmentType.duration, "m")
      //   .toISOString();

      // return { utcStartHour, utcEndHour };
      const utcStartHour = moment(
        `${this.booking.date} ${this.selectedSlot[0]}`,
        "YYYY-MM-DD hh:mm A"
      ).toISOString();
      const utcEndHour = moment(
        `${this.booking.date} ${this.selectedSlot[1]}`,
        "YYYY-MM-DD hh:mm A"
      ).toISOString();
      return { utcStartHour, utcEndHour };
    },

    async doBooking() {
      if (this.booking.date && this.booking.startHour) {
        this.loading = true;
        const { utcStartHour, utcEndHour } = this.getUtcDates();
        const object = {
          doctorId: this.$route.params.doctorId,
          bookingTypeId: this.selectedAppointmentType._id,
          bookingStartDate: utcStartHour,
          bookingEndDate: utcEndHour,
          timeZone: momentTimezone.tz.guess(),
          rescheduleReason: this.rescheduleReason
        };
        const bookingResponse = await BookingService.updateBooking(
          this.bookingDetails.bookingId,
          object
        );
        if (bookingResponse) {
          this.$router.push({ name: "Bookings" });
        }
        this.loading = false;
      } else {
        this.$store.dispatch(
          "user/setSnack",
          "Select valid booking date & booking time.!"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.dialog = false;
    },
    bookingInitiated(recurringBooking) {
      if (this.booking.date) {
        this.loading = true;
        const { utcStartHour, utcEndHour } = this.getUtcDates();
        const object = {
          bookingStartDate: utcStartHour,
          bookingEndDate: utcEndHour,
          doctorId: this.$route.params.doctorId,
          bookingTypeId: this.selectedAppointmentType._id,
          timeZone: momentTimezone.tz.guess()
        };
        const date = this.booking.date
          .split("-")
          .reverse()
          .join(".");
        const startTime = moment(utcStartHour).format("hh:mm A");
        const endTime = moment(utcEndHour).format("hh:mm A");
        const slotDetails = { date, startTime, endTime };

        this.bookingModal = false;
        this.$emit(
          "bookingInitiated",
          object,
          this.selectedAppointmentType,
          slotDetails,
          recurringBooking
        );
      } else {
        this.$store.dispatch(
          "user/setSnack",
          "You should enter a valid booking date & booking time.!"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.loading = false;
    },
    /*     async bookNow() {
      if (this.booking.date) {
        this.loading = true;
        const { utcStartHour, utcEndHour } = this.getUtcDates();
        const object = {
          bookingStartDate: utcStartHour,
          bookingEndDate: utcEndHour,
          doctorId: this.$route.params.doctorId,
          addressId: this.$route.params.addressId,
          amount: this.selectedAppointmentType.fees,
          timeZone: momentTimezone.tz.guess()
        };
        const bookingResponse = await BookingService.create(object);
        if (bookingResponse) {
          this.$emit(
            "bookingDone",
            bookingResponse.data.id,
            this.selectedAppointmentType
          );
        }
      } else {
        this.$store.dispatch(
          "user/setSnack",
          "You should enter a valid booking date & booking time.!"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.loading = false;
      this.bookingModal = false;
    }, */
    async updateBooking() {
      this.bookingModal = false;
      if (this.booking.date && this.booking.startHour) {
        this.dialog = true;
        return;
      } else {
        this.$store.dispatch(
          "user/setSnack",
          "You should enter a valid booking date & booking time.!"
        );
        this.$store.dispatch("user/setType", "error");
      }
    },
    login() {
      this.$router.push("/login");
    },
    changeDoctor() {
      this.$router.push("/find-doctor");
    }
  }
};
</script>
<style scoped type="text/css">
.book-appointment {
  text-transform: none;
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 16px;
  width: 240px;
}
.book-appointment-title {
  font-weight: 500;
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 20px;
  color: #27445b;
}
.type-select {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 16px;
  color: #0c1f36;
}
.date-time {
  font-family: "Now Alt";
  font-weight: 400;
  font-size: 16px;
  color: #27445b;
}
.list {
  font-size: 16px;
  color: #27445b;
}
.text-transform {
  text-transform: initial !important;
  color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.cancel-btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.scroll-box {
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
.card-sub {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #27445b;
}
.border-top {
  border-top: 1px dashed #c5cdd6;
}
.payment-card-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.75px;
  color: #0c1f36;
}
.save-details {
  font-size: 15px !important;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #677c95;
}
.payment-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #27445b;
}
.billDeatils-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #27445b;
}
.appointmentDetails-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  color: #27445b;
}
.border-payment {
  border: 0.5px dashed #c5cdd6;
}
.v-navigation-drawer {
  will-change: initial;
  z-index: 999999 !important;
}
.btn-style {
  font-size: 11px;
}
.selected-style {
  color: #096dd8;
}
.no-card-shadow {
  box-shadow: none !important;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  margin: 0px;
}
</style>
